import React, { useContext, useEffect } from 'react'
import {
    Container,
} from 'reactstrap'
import { withRouter } from 'react-router-dom'
import DataTable from './components/Datatable'
import { GeneralContext } from '../../context/'

export default withRouter(() => {
    const generalContext = useContext(GeneralContext)
    const { setBreadcrumb } = generalContext

    useEffect(() => {
        setBreadcrumb({
            icon: '',
            parent: `Pedidos`,
            parentLink: '/sales-order',
            item: `Historial de Pedidos`
        })

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DataTable />
                </Container>
            </div>
        </React.Fragment>       
    )
})